import { SOPHON_APP_ID, THREE_JAN_APP_ID } from "./constants";

export function extractDomain(url: string): string {
  url = url.replace(/\s+/g, "");
  const regex = /^https?:\/\/([^/]+)/;
  const match = url.match(regex);
  if (match) {
    const domain = match[1];
    const parts = domain.split(".");
    if (parts.length >= 3) {
      return parts[1];
    } else {
      return parts[0];
    }
  }
  return url;
}

export interface ResponseMatch {
  value?: string;
  type?: string;
  invert: boolean;
  description?: string;
  order?: number;
}

export function extractVariablesFromResponseMatches(responseMatches: ResponseMatch[]): string[] {
  if (!responseMatches?.length) {
    return [];
  }

  const variablePattern = /\{\{(.*?)\}\}/g;
  const variables = new Set<string>();

  responseMatches.forEach((responseMatch) => {
    const value = responseMatch.value || "";
    const matches = value.matchAll(variablePattern);

    for (const match of matches) {
      if (match[1]) {
        variables.add(match[1].replace(/_/g, " "));
      }
    }
  });

  return Array.from(variables);
}

export const formatVariables = (variables: string[]): string => {
  const formattedVariables = variables.map((variable) =>
    variable
      .split(" ")
      .filter((word) => word.length > 0)
      .join(" ")
  );

  if (formattedVariables.length === 0) {
    return "your data";
  } else if (formattedVariables.length === 1) {
    return formattedVariables[0];
  } else if (formattedVariables.length === 2) {
    return `${formattedVariables[0]} and ${formattedVariables[1]}`;
  } else {
    const allButLast = formattedVariables.slice(0, -1).join(", ");
    const last = formattedVariables[formattedVariables.length - 1];
    return `${allButLast}, and ${last}`;
  }
};

export const isSophonApp = (appId: string) => {
  return appId.toLowerCase() === SOPHON_APP_ID.toLowerCase();
};

export const isThreeJanApp = (appId: string) => {
  return appId.toLowerCase() === THREE_JAN_APP_ID.toLowerCase();
};